import { createFileRoute } from '@tanstack/react-router';

// relative imports
import TirAdminClientListContainer from '../../components/dashboard/components/tir-admin-client-list/TirAdminClientListContainer';
import LoadingPage from '../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute('/_authenticated/clients')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: TirAdminClientListContainer,
  staticData: {
    configPageId: 'clients',
    meta: {
      title: 'Clients | Ledgible',
    },
  },
});
